import $ from "jquery";

function searchletError(root, msg) {
    console.log('Searchlet error: ' + msg);
    root.html('<span class="searchlet-error">Searchlet error, please check console log for details.</span>');
}

export function getApiToken(apiKey, root, callback) {
    var rest_token_url = 'https://' + DOMAIN + '/api/get-token';

    $.ajax({
        url: rest_token_url,
        data: {
            domain: window.location.hostname
        },
        headers: {
            "X-API-KEY": apiKey
        },
        success: function(response) {
            if (response.success !== true) {
                searchletError(root, response.message)
                return;
            }
            let apiToken = response.token;
            callback(apiToken)
        },
        error: function() {
            searchletError(root, 'Connection to API failed. Probably you used a wrong URL or the API is unavailable.');
        }
    });
}